import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    useTheme,
} from '@mui/material';
import Button from '@/components/ui/Button/Button';
import type { ConfirmDialogProps } from './IConfirmDialog';
import { styles } from './styles';

const ConfirmDialog = ({
    open,
    title = 'Confirm',
    message,
    confirmLabel = 'Confirm',
    cancelLabel = 'Cancel',
    onConfirm,
    onCancel,
    danger = false,
    loading = false,
}: ConfirmDialogProps) => {
    const theme = useTheme();
    return (
        <Dialog
            open={open}
            onClose={(_, reason) => {
                if (loading && reason === 'backdropClick') return;
                onCancel();
            }}
            maxWidth="xs"
            fullWidth
        >
            <DialogTitle sx={styles.title}>{title}</DialogTitle>
            {message && (
                <DialogContent>
                    <DialogContentText sx={styles.message}>
                        {message}
                    </DialogContentText>
                </DialogContent>
            )}
            <DialogActions>
                <Button onClick={onCancel} disabled={loading}>
                    {cancelLabel}
                </Button>
                <Button
                    variant="contained"
                    sx={styles.confirmBtn(danger, theme)}
                    onClick={onConfirm}
                    loading={loading}
                >
                    {confirmLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog;
